import { useAuthingGuard } from './authing-guard/hook';
import { useRefreshAccessToken } from './refresh-access-token/hook';
import { useLogin } from './login/hook';

export const Auth = {
  useLogin,
  useRefreshAccessToken,
  useAuthingGuard,
};
